import React from 'react';
import { Box, Card, CardContent, CardProps } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import {
    EXTRA_HOT_COLOR,
    HOT,
    WARM,
    COLD,
    NONE,
    HOT_COLOR,
    WARM_COLOR,
    NONE_COLOR,
    EXTRA_HOT,
    COLD_COLOR,
} from 'src/constants/lead/ratings';
import { Label } from 'src/components/Tags';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        gap: 30,
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
    },
    label: {
        padding: 20,
        borderRadius: 15,
    },
}));

/**
 * Helper component to display the ratings labels in the charts
 *
 * @return {*}
 */
export const RatingsLabels = ({ style, ...props }: CardProps) => {
    const { t } = useTranslation();
    const classes = useStyles();

    const RatingContainer = ({
        color,
        labelType,
        label,
    }: {
        color: string;
        labelType: string;
        label: string;
    }) => (
        <Label color={labelType} className={classes.label}>
            <Box style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <Box
                    style={{
                        backgroundColor: color,
                        height: 20,
                        width: 20,
                        borderRadius: '50%',
                    }}
                />
                <span>{label}</span>
            </Box>
        </Label>
    );

    return (
        <Card elevation={0} {...props}>
            <CardContent style={{ padding: 10 }} className={classes.root}>
                {RatingContainer({
                    color: EXTRA_HOT_COLOR,
                    labelType: EXTRA_HOT,
                    label: t('Status.extra hot'),
                })}
                {RatingContainer({
                    color: HOT_COLOR,
                    labelType: HOT,
                    label: t('Status.hot'),
                })}
                {RatingContainer({
                    color: WARM_COLOR,
                    labelType: WARM,
                    label: t('Status.warm'),
                })}
                {RatingContainer({
                    color: COLD_COLOR,
                    labelType: COLD,
                    label: t('Status.cold'),
                })}
                {RatingContainer({
                    color: NONE_COLOR,
                    labelType: NONE,
                    label: t('Status.none'),
                })}
            </CardContent>
        </Card>
    );
};
